
function toggleVisibility(section) {
  const hideIfEmpty = !!parseInt(section.dataset.hideIfEmpty || null, 10);
  const hidePreviousIfEmpty = !!parseInt(section.dataset.hidePreviousIfEmpty || null, 10);

  if(!hideIfEmpty) return;

  const previous = hidePreviousIfEmpty && section.previousElementSibling?.classList.contains('wp-block-takt-content-with-media') ? section.previousElementSibling : null;

  if(section.querySelectorAll(".menu-section-items>ul>li:not(.hidden\\!)").length == 0){
    section.classList.add('hidden!');
    previous?.classList.add('hidden!');
  }else{
    section.classList.remove('hidden!');
    previous?.classList.remove('hidden!');
  }
}

function sortItems(section) {
  const sort = !!parseInt(section.dataset.sort || null, 10);
  if(!sort) return;

  const items = Array.from(section.querySelectorAll('.menu-item')).map((element) => {
    const item = element.parentElement;
    const priceElement = element.querySelector('[data-price-display]');
    const priceStr = priceElement?.innerText.trim() || '';
    
    const match = priceStr.match(/([0-9]+)([½¼¾]?)/);
    let price = null;
    
    if (match) {
      let num = match[1];
      let frac = match[2];
      let decimal = 0;
      
      if (frac === '½') {
        decimal = 0.5;
      } else if (frac === '¾') {
        decimal = 0.75;
      } else if (frac === '¼') {
        decimal = 0.25;
      }

      price = parseFloat(num) + decimal;
    }

    if (price === null || isNaN(price)) {
      price = Number.MAX_SAFE_INTEGER;
    }

    return { item, price };
  });

  items.sort((a, b) => a.price - b.price);

  const parent = section.querySelector('.menu-section-items>ul');
  if(parent){
    items.forEach(({ item }) => {
      parent.appendChild(item);
    });
  }  
}

function toggleVisibilityForAll() {
  document.querySelectorAll(".menu-section").forEach((element) => {
    toggleVisibility(element);
  });
}

function sortItemsForAll() {
  document.querySelectorAll(".menu-section").forEach((element) => {
    sortItems(element);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  toggleVisibilityForAll();
  sortItemsForAll()
  document.body.addEventListener('venueChanged', toggleVisibilityForAll);
  document.body.addEventListener('venueChanged', sortItemsForAll);
});
